// src/components/sections/HeroSection.js
import { Link } from 'react-router-dom';
import { useLang } from '../../i18n/LanguageContext';
import { useSiteConfig } from '../../context/SiteConfigContext';
import CandleSVG from '../candles/CandleSVG';
import styles from './HeroSection.module.css';

const FLOATING_CANDLES = [
  { shape: 'heart',  color: '#f9a8c9', cls: 'f1', size: 88 },
  { shape: 'rose',   color: '#c8a2c8', cls: 'f2', size: 72 },
  { shape: 'bubble', color: '#fde68a', cls: 'f3', size: 66 },
  { shape: 'gift',   color: '#e9d5ff', cls: 'f4', size: 78 },
  { shape: 'circle', color: '#fbcfe8', cls: 'f5', size: 58 },
  { shape: 'cube',   color: '#bfdbfe', cls: 'f6', size: 62 },
];

export default function HeroSection() {
  const { t, ui } = useLang();
  const { config } = useSiteConfig();

  const stats = [
    { value: config.stat_orders_value,       label: t(config, 'stat_orders_label') },
    { value: config.stat_satisfaction_value, label: t(config, 'stat_satisfaction_label') },
    { value: config.stat_delivery_value,     label: t(config, 'stat_delivery_label') },
  ];

  return (
    <section className={styles.hero} id="hero">
      {/* Ambient background */}
      <div className={styles.bgRadial} />

      {/* Floating candle illustrations */}
      {FLOATING_CANDLES.map(({ shape, color, cls, size }, i) => (
        <div key={i} className={`${styles.floater} ${styles[cls]}`}>
          <CandleSVG shape={shape} color={color} size={size} />
        </div>
      ))}

      {/* Main content */}
      <div className={styles.content}>
        <div className={styles.badge}>
          {ui('✦ هنر شمع‌سازی دست‌ساز ✦', '✦ Handmade Candle Art ✦')}
        </div>

        <h1 className={styles.title}>{t(config, 'brand_name')}</h1>

        <p className={styles.tagline}>{t(config, 'tagline')}</p>

        <p className={styles.subtitle}>{t(config, 'hero_subtitle')}</p>

        <div className={styles.ctas}>
          <Link to="/portfolio" className="btn-primary">
            {ui('مشاهده نمونه‌کارها 🕯️', 'View Portfolio 🕯️')}
          </Link>
          <a href="#contact" className="btn-secondary">
            {ui('سفارش دهید', 'Order Now')}
          </a>
        </div>

        <div className={styles.stats}>
          {stats.map(({ value, label }) => (
            <div key={label} className={styles.stat}>
              <span className={styles.statValue}>{value}</span>
              <span className={styles.statLabel}>{label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className={styles.scrollIndicator}>
        <div className={styles.scrollDot} />
      </div>
    </section>
  );
}
